import * as API from '@/services/api';

export async function fetchTranslations(language, textType, filter) {
  const filterQuery = filter ? `&filter=${filter}` : '';
  const response = await API.get(`/api/i18ns?language=${language}&textTypeParameter=${textType}${filterQuery}`);
  return response.data;
}
